/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Color_By_Reason_Threshold_PaceInputs */

const en_ui_color_by_reason_threshold_pace = /** @type {(inputs: Ui_Color_By_Reason_Threshold_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set your threshold pace in your profile`)
};

const de_ui_color_by_reason_threshold_pace = /** @type {(inputs: Ui_Color_By_Reason_Threshold_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trag deine Schwellenpace in deinem Profil ein`)
};

/**
* | output |
* | --- |
* | "Set your threshold pace in your profile" |
*
* @param {Ui_Color_By_Reason_Threshold_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_color_by_reason_threshold_pace = /** @type {((inputs?: Ui_Color_By_Reason_Threshold_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Color_By_Reason_Threshold_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_color_by_reason_threshold_pace(inputs)
	return de_ui_color_by_reason_threshold_pace(inputs)
});